import { t } from 'utilities/TranslationUtils';

export const InviteExpiredPage = () => {
  return (
    <div>
      <h1>{t('common.inviteExpired')}</h1>
      <p>{t('common.inviteExpiredText')}</p>
    </div>
  );
};

export default InviteExpiredPage;
